export default "__VITE_ASSET__95187ec6__"